import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Users, Star, Calendar, Award } from 'lucide-react';

const StatsSection = () => {
  const { language } = useLanguage();

  const stats = [
    {
      icon: <Users className="w-8 h-8" />,
      number: "1,500+",
      label: language === 'en' ? 'Happy Clients' : 'Ευχαριστημένοι Πελάτες'
    },
    {
      icon: <Star className="w-8 h-8" />,
      number: "4.9/5",
      label: language === 'en' ? 'Average Rating' : 'Μέση Αξιολόγηση'
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      number: "3,000+",
      label: language === 'en' ? 'Cleanings Completed' : 'Ολοκληρωμένοι Καθαρισμοί'
    },
    {
      icon: <Award className="w-8 h-8" />,
      number: "4",
      label: language === 'en' ? 'Years Experience' : 'Χρόνια Εμπειρίας'
    }
  ];

  return (
    <section className="py-16 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #87CEEB 0%, #B0E0E6 100%)' }}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="container relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 stagger-children">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="text-center text-white"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm mb-4 animate-float" style={{ animationDelay: `${index * 0.2}s` }}>
                {stat.icon}
              </div>
              <div className="text-4xl md:text-5xl font-bold mb-2">{stat.number}</div>
              <div className="text-sm md:text-base opacity-90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
